// Get Memory entries without depending on timeline.memories,
// which depends on hours.draft and friends

import type { RelevantMemoryFilters } from 'redux/modules/timeline.types';
import { getFilter as getCalendarFilter } from 'redux/selectors/calendar.filter';
import { getFilter, getTimelineEntities, getTimelineResult } from 'redux/selectors/timeline';
import { createSelector } from 'reselect';
import type { Entry } from 'types/timeline';

export const getCalendarDate = createSelector([getCalendarFilter], (calendarFilter): string => {
  return calendarFilter.date;
});

export const getRelevantMemoryFilters = createSelector(
  [getFilter, getCalendarDate],
  (filter, date): RelevantMemoryFilters => {
    return {
      date,
      expandedEntryIds: filter.expandedEntryIds,
      noiseMinThreshold: filter.noiseMinThreshold,
      importanceMinThreshold: filter.importanceMinThreshold,
      mode: filter.mode,
      // This is expensive, yo. Perhaps not do this here?
      searchQuery: filter.searchQuery,
      timeFormat: filter.timeFormat,
    };
  }
);

export const getMemoryEntries = createSelector(
  [getTimelineEntities, getTimelineResult],
  (entities, result): Array<Entry> => result.map(id => entities[id])
);
